export default __webpack_public_path__ + "static/media/hori-light.17a41b33.png";